import React from 'react'
import PropTypes from 'prop-types'
import { formatTime } from 'utils/timer'

export const BreakTimer = ({
  classes,
  countdownValue,
  breakDesc,
  stopDumoTimer,
}) => (
  <div>
    <h1 className={classes.centered}>{breakDesc}</h1>
    <div className={classes.timerWindow} onClick={stopDumoTimer}>
      {formatTime(countdownValue)}
    </div>
  </div>
)

BreakTimer.propTypes = {
  classes: PropTypes.object,
  stopDumoTimer: PropTypes.func.isRequired,
  countdownValue: PropTypes.number.isRequired,
  breakDesc: PropTypes.string.isRequired,
}

export default BreakTimer



// WEBPACK FOOTER //
// ./src/components/BreakTimer/BreakTimer.js